import $ from 'jquery';

export default function ConfigStuff(vm) {
    this.all = function (params) {
        var url = '/config/stuff/list?' + $.param(params);

        return vm.get(url);
    };

    this.create = function (params) {
        var url = '/config/stuff/create';

        return vm.post(url, params);
    };
}